<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />

        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("vincular-prazo-pagamento") }}
            </h1>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="usuarios"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'descricao' ">
                        <a @click="select(props.row)">
                            {{ props.row[f.key] }}
                        </a>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import PrazoPagtoService from "@/services/vendas/prazopagto/PrazoPagtoService";

export default {
    props: {
        idempresa: 0,
    },
    data() {
        return {
            service: new PrazoPagtoService(this.$http, this.$router),
            usuarios: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'descricao', width: null, sortable: true, sortFn: null }
            ],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],

            isVenda: this.$route.meta.contexto == "vendas",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idempresa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.usuarios = value;
                this.isEmpty = this.usuarios.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findNaoAssociados(column, order, page, limit, idempresa, ...params) {
            if (this.isVenda) {
                return this.service
                .findNaoAssociadosVendas(column, order, page, limit, idempresa, ...params);
            }else {
                return this.service
                .findNaoAssociadosAgro(column, order, page, limit, idempresa, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idempresa: +this.idempresa,
                    idprazopagto: m.idprazopagto,
                    descricao: m.descricao,
                    idassprazopagtoempresa: null
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        select(selected) {
            this.$emit('selected', selected);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
